import { useState } from 'react';
import { IRadioGroupOption } from '../../components/RadioGroup/types';

export type Strategy = 'create' | 'update';
interface IProps {
  defaultStrategy: Strategy;
  /**
   * permittedStatus is a map of the permitted status for each strategy
   * Passing undefined if no permitted implemented.
   */
  permittedStatus?: Record<Strategy, boolean>;
}
const strategyOptions: Array<{ label: string; value: Strategy }> = [
  {
    label: 'Create New',
    value: 'create',
  },
  {
    label: 'Update Existing',
    value: 'update',
  },
];

export default ({ defaultStrategy, permittedStatus }: IProps) => {
  const [strategy, setStrategy] = useState<Strategy>(defaultStrategy);

  const handleChangeStrategy = (newStrategy: string) => {
    setStrategy(newStrategy as Strategy);
  };

  const strategyOptionsWithPermitted: IRadioGroupOption[] = strategyOptions.map(
    (option) => {
      const permitted = permittedStatus ? permittedStatus[option.value] : true;
      return {
        ...option,
        disabled: !permitted,
      };
    },
  );
  return {
    strategy,
    setStrategy: handleChangeStrategy,
    strategyOptions: strategyOptionsWithPermitted,
  };
};
